import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import {List, Map} from 'immutable';
import {FileUploadId} from 'records/CoachingReviewFileUpload';
import CallCardStore from '@store/call-card/CallCardStore';
import UserStore from 'stores/UserStore';
import {sortCallSpeakers} from '@components/call-card/CallSpeaker.utils';
import {ExternalCallCard} from './ExternalCallCard';
import Loading from 'components/pure/utils/Loading';
import CallCardActions from '@store/call-card/CallCardActions';
import {isValidTime, SharedAreas} from '@components/call-card/SharedHighlights.utils';

interface ExternalCallCardContainerProps {
  callId: FileUploadId;
  sharedAreas: SharedAreas;
}

@connectToStores
class ExternalCallCardContainer extends React.PureComponent<
  ExternalCallCardContainerProps & ReturnType<typeof ExternalCallCardContainer.getPropsFromStores>
> {
  static getStores() {
    return [CallCardStore, UserStore];
  }

  static getPropsFromStores({callId, sharedAreas}) {
    const {calls, callAssets, speakers, transcripts, segments, talkTimes} =
      CallCardStore.getState();
    const call = calls.get(callId);
    const callTalkTime = talkTimes.get(callId, Map());
    const callSpeakers = sortCallSpeakers(speakers.get(callId, List()), call, callTalkTime);
    const transcript = sharedAreas.isEmpty()
      ? transcripts.get(callId, List())
      : transcripts
          .get(callId, List())
          .filter(
            t => isValidTime(sharedAreas, t.startTime) || isValidTime(sharedAreas, t.endTime)
          );

    return {
      call,
      callAsset: callAssets.get(callId),
      segments: segments.get(callId, List()),
      speakers: callSpeakers,
      talkTime: callTalkTime,
      transcript,
    };
  }

  async componentDidMount() {
    const callId = this.props.callId;
    // Skip if data was already hydrated from the external share bundle
    const {calls} = CallCardStore.getState();
    if (calls.has(callId)) return;

    return Promise.all([
      CallCardActions.getCall(callId),
      CallCardActions.getCallSource(callId),
      CallCardActions.getSpeakers(callId),
      CallCardActions.getSegments(callId),
      CallCardActions.getTranscript(callId),
    ]);
  }

  render() {
    const {call} = this.props;

    if (!call) return <Loading />;

    return <ExternalCallCard {...this.props} call={call} />;
  }
}

export default ExternalCallCardContainer as unknown as React.FC<ExternalCallCardContainerProps>;
